module.exports = __webpack_public_path__ + "static/media/willkommensbesuche.21f2bb19.jpg";